<template>
  <b-tabs v-model="currentTab" v-on:activate-tab="activateTab">
    <b-tab title="Profile"><Profile/></b-tab>
    <b-tab title="Settings"><Settings/></b-tab>
    <b-tab title="Payment"><Payment/></b-tab>
    <b-tab title="Invoices"><Invoices/></b-tab>
    <b-tab title="GDPR"><DpaInfo/></b-tab>
    <b-tab title="Support"><Support/></b-tab>
  </b-tabs>
</template>

<script>
import Profile from './Profile'
import Settings from './Settings'
import Payment from './Payment'
import Invoices from './Invoices'
import DpaInfo from './DpaInfo'
import Support from './Support'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'TheUser',
  components: {
    Profile,
    Payment,
    Invoices,
    DpaInfo,
    Support,
    Settings
  },

  computed: {
    currentTab: {
      get () {
        return this.$store.getters.tab
      },
      set (value) {
        // just do nothing
      }
    }
  },

  methods: {
    ...mapActions('user', [
      'getAccount',
      'getUser'
    ]),

    ...mapActions('invoice', [
      'getCostsCurrentMonth'
    ]),

    ...mapActions('support', [
      'getTags',
      'getTickets'
    ]),

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    activateTab (next) {
      let name = ''
      switch (next) {
        case 0:
          name = 'userProfile'
          this.setViewname(this.$t('user.profile.viewtitle'))
          break
        case 1:
          name = 'settings'
          this.setViewname(this.$t('user.settings.viewtitle'))
          break
        case 2:
          name = 'userPayment'
          this.setViewname(this.$t('user.payment.viewtitle'))
          break
        case 3:
          name = 'userInvoices'
          this.setViewname(this.$t('user.invoices.viewtitle'))
          break
        case 4:
          name = 'dpaInfo'
          this.setViewname(this.$t('user.dpainfo.viewtitle'))
          break
        case 5:
          name = 'support'
          this.setViewname(this.$t('user.support.viewtitle'))
          break
      }

      this.$router.push({
        name: name
      })
    }
  },

  created () {
    Promise.all([this.getUser(), this.getAccount(), this.getCostsCurrentMonth(), this.getTags(), this.getTickets()])
      .then(
        this.endLoading
      )
  }
}
</script>
